import { Link, useLocation } from "react-router-dom";
import { Mail, Facebook, Linkedin, Instagram } from "lucide-react";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const location = useLocation();

  // 🔹 Hide footer on login routes
  if (location.pathname === "/login" || location.pathname === "/admin/login") {
    return null;
  }

  return (
    <footer
      className={`relative z-50 ${
        location.pathname === "/" ? "bg-white/40" : "border-t-1 bg-white"
      } text-black shadow-lg backdrop-blur-md`}
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div>
            <div className="mb-6 flex items-center space-x-3">
              <div className="h-12 w-[180px]">
                <img src="/logo-cropped.svg" alt="Logo" />
              </div>
            </div>
            <p className="text-black-300 mb-6 max-w-md">
              Leading maritime services provider with a global presence and
              commitment to excellence in seafarer training and certification.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/timesnautilus"
                className="text-black-400 transition-colors hover:text-teal-400"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://x.com/TimesNautilus"
                className="text-black-400 transition-colors hover:text-teal-400"
              >
                <FaXTwitter size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/nautilus-times/"
                className="text-black-400 transition-colors hover:text-teal-400"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/times_nautilus/"
                className="text-black-400 transition-colors hover:text-teal-400"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-6 text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/courses"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Certifications
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="mb-6 text-lg font-semibold">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/refund"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/shipping"
                  className="text-black-300 transition-colors hover:text-teal-400"
                >
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-6 text-lg font-semibold">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-1 flex-shrink-0 text-teal-400" />
                <div className="space-y-2 text-sm">
                  {/* General */}
                  <div>
                    <p className="font-semibold text-black-300">General</p>
                    <a
                      href="mailto:info@nautilustimes.com"
                      className="text-black-300 hover:text-teal-400"
                    >
                      info@nautilustimes.com
                    </a>
                  </div>

                  {/* Training */}
                  <div>
                    <p className="font-semibold text-black-300">
                      Training Queries
                    </p>
                    <a
                      href="mailto:training@nautilustimes.com"
                      className="text-black-300 hover:text-teal-400"
                    >
                      training@nautilustimes.com
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800 pt-8 text-center">
          <p className="text-black-400">
            &copy; {new Date().getFullYear()} Nautilus Times. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
